<template>
    <div class="col-12 col-sm-12 col-md-5">
        <nav class="mid-right-nav" v-bind:aria-label="$t('message.language-chooser')">
            <ul>
                <li :class="isSelectedLocale('nbo')">
                    <a class="language-chooser-link" href="javascript:void(0)" lang="nb" @click="changeLocale('nbo')">Bokmål</a>
                </li>
                <li :class="isSelectedLocale('nny')">
                    <a class="language-chooser-link" href="javascript:void(0)" lang="nn" @click="changeLocale('nny')">Nynorsk</a>
                </li>
                <li :class="isSelectedLocale('eng')">
                    <a class="language-chooser-link" href="javascript:void(0)" lang="en" @click="changeLocale('eng')">English</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "Language",
    methods: {
        isSelectedLocale(val) {
            let value = 'language-chooser-li';
            if (this._i18n != undefined && this._i18n._vm != undefined && this._i18n._vm.locale != undefined) {
                if (this._i18n._vm.locale == val) {
                    value += ' selected';
                }
            }

            return value;
        },
        changeLocale(val) {
            this._i18n._vm.locale = val;
            localStorage.setItem("lang", val);
            let hash = window.location.hash;
            if (!hash.includes('ui-lang')) {
                window.location.reload();
            }
        }
    }
};
</script>
